const Report = () =>
  import(/* webpackChunkName: "orders" */ '@/pages/order/points/index.vue')

export default {
  name: 'PointsReport',
  path: 'points',
  meta: {
    title: 'nav.pointsReport'
  },
  component: Report
}
